<template>
  <page-outline :title="$t('mandate.bank_selection_title') || 'Sélection de votre banque'">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="mt-3">
          <b-col cols="12" class="d-flex justify-content-start">
            <back-button class="btnFilter_2" :returnUrl="'/modechoice'"></back-button>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col cols="12" md="6" class="mx-auto">
            <input
              v-model.trim="search"
              class="filter-item-content w-100"
              style="padding: 0.35rem 0.5rem 0.35rem 0.7rem;"
              :placeholder="$t('mandate.search_bank') || 'Rechercher votre banque'"
            />
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col
            v-for="bank in filteredBanks"
            :key="bank.id"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="mb-3"
          >
            <div class="bank-card" @click="selectBank(bank)">
              <div class="bank-logo-placeholder">
                {{ bank.name.charAt(0) }}
              </div>
              <span class="bank-name">{{ bank.name }}</span>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="filteredBanks.length === 0" class="mt-4">
          <b-col cols="12" class="d-flex justify-content-center">
            <span class="noResult">{{ $t('common.no_result') || 'Aucune banque trouvée' }}</span>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import BackButton from '@/components/common/backButton.vue'
import { loadPage } from '@/helpers/routing'

export default {
  name: 'BankSelection',
  components: {
    'page-outline': PageOutline,
    'back-button': BackButton
  },
  data () {
    return {
      search: '',
      banks: [
        { id: 'ca', name: 'Crédit Agricole' },
        { id: 'bnp', name: 'BNP Paribas' },
        { id: 'sg', name: 'Société Générale' },
        { id: 'lcl', name: 'LCL' },
        { id: 'cm', name: 'Crédit Mutuel' },
        { id: 'bp', name: 'Banque Populaire' },
        { id: 'ce', name: 'Caisse d\'Épargne' },
        { id: 'la-banque-postale', name: 'La Banque Postale' },
        { id: 'hsbc', name: 'HSBC France' },
        { id: 'boursorama', name: 'Boursorama Banque' },
        { id: 'ing', name: 'ING Direct' },
        { id: 'fortuneo', name: 'Fortuneo' }
      ]
    }
  },
  computed: {
    filteredBanks () {
      if (!this.search) return this.banks
      const q = this.search.toLowerCase()
      return this.banks.filter(b => b.name.toLowerCase().includes(q))
    }
  },
  methods: {
    goBack () {
      loadPage(this, { url: '/modechoice' })
    },
    selectBank (bank) {
      // TODO: brancher vers le flux d'authentification AIS réel (Powens/Bridge/Budget Insight...)
      // Pour l'instant, redirection vers une page de connexion fictive avec le code banque en query
      loadPage(this, { url: '/bankauth?bank=' + bank.id })
    }
  }
}
</script>

<style scoped>
.bank-card {
  background: var(--actionTextColorWhite);
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: var(--borderRadius);
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  height: 100%;
}

.bank-card:hover {
  border-color: var(--actionButtonColorBlue);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.bank-logo-placeholder {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--actionButtonColorBlue);
  color: var(--actionTextColorWhite);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.2rem;
  margin-bottom: 0.75rem;
}

.bank-name {
  text-align: center;
  font-weight: 500;
  color: var(--actionTextColorBlack);
}
</style>